/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import MyModalHeader from "../../../globals/ModalHeader";
import Loader from "../../../globals/Loader";
import "./style.scss";
import { apiCall } from "../../../../helpers/ApiCalls";
import { showMessage } from "../../../globals/Message";
import ConsignacionesGrid from "./Grid";
import localStorage from "local-storage";
const ModalUPCCompras = (props) =>{
  const {
    show,
    producto,
    onHide,
    filtroConfig
  } = props;

  const[ready,setReady] = useState(false);

  const[readyGrid,setReadyGrid] = useState(false);
  const[gridData,setGridData] = useState([]);

  function handleHide(){
    setReady(false);
    setReadyGrid(false);
    setGridData([]);
    onHide();
  }

  /** Evento cada que se abre el modal */
  useEffect(()=>{
    if(show){
      console.log(">>> se abre el modal",producto,filtroConfig);
      apiCall('POST','reporte/consignacion_upc',{
        id_proveedor:localStorage.get('id_proveedor')??0,
        upc:producto.id
      }).then((res) => {
        start(res)
      })
    }
  },[show])

  function start(res){
    try {
      if(res.success){
        showMessage("Consignaciones por ID Compra",'success');
        setReady(true);
        setGridData(res.data);
        setTimeout(() => {
          setReadyGrid(true);
        }, 200);
      }
      else{
        showMessage(res.message,'error');
      }
    } catch (error) {
      console.log("Ocurrio un error", error)

    }
    
  }

  return (
    <Modal
      centered
      show      = {show}
      onHide    = {handleHide}
      animation = {false}
      dialogClassName="modal-consignaciones"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <MyModalHeader
        handleHide={handleHide}
      >
        <div>
          <span style={{
            fontSize:'1.2em',
            fontWeight:'700'
          }}>Historico de Consignaciones por UPC
        </span>

          <span style={{
            fontSize:'1em',
            fontWeight:'600'

          }}> - {producto.id} - {producto.nombre} - {producto.plataforma} </span>
        </div>
      </MyModalHeader>
      <Modal.Body>
        <Row>
          <Col>
            <div className="content-wrapper">
              {
                ready ?
                (
                  <ConsignacionesGrid
                    data={gridData}
                    ready={readyGrid}
                  />
                )
                :
                (
                  <Loader/>
                )
              }
              

            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  )
}
export default ModalUPCCompras;